// extracted by mini-css-extract-plugin
module.exports = {"no-changes-body":"NoChangesBody_no-changes-body__1Bsx5","content":"NoChangesBody_content__2pwhd","emoji":"NoChangesBody_emoji__n1NY4"};